import React from "react"
import { Box, List, Skeleton } from "@mui/material"

import SidebarItem from "components/SidebarItem"
import { useSavedProductCollections } from "context/api"
import SecondarySidebarBase from "./SecondarySidebarBase"

type SavedProductCollection = {
  collection_id: string
  collection_name: string
  created_by: string
  created_date: string
  products: {
    product_id: string
    company_id: string
  }[]
}
type SavedProductCollections = SavedProductCollection[]

export default function SecondarySidebarProductCollections() {
  const savedCollectionsQuery = useSavedProductCollections()
  const savedCollections: SavedProductCollections =
    savedCollectionsQuery?.data || []

  return (
    <SecondarySidebarBase>
      <Box
        sx={{
          pt: 1.5,
          px: 2.5,
          fontSize: "sm",
          fontWeight: 600,
          color: "gray.700",
        }}
        my={1}
        display="flex"
        alignItems="center"
        gap={1}
      >
        Saved Collections
      </Box>
      <List sx={{ pt: 0.5, pb: 0 }}>
        {savedCollectionsQuery?.isLoading && (
          <Skeleton
            sx={{
              mx: 2.5,
            }}
          />
        )}
        {!!savedCollections?.length ? (
          savedCollections.map((productCollection: SavedProductCollection) => (
            <SidebarItem
              key={productCollection.collection_id}
              title={productCollection.collection_name}
              href={{
                pathname: `/dashboard/product-research/collections/[collectionId]`,
                query: {
                  collectionId: productCollection.collection_id,
                },
              }}
              activePaths={[
                {
                  path: `/dashboard/product-research/collections/${productCollection.collection_id}`,
                  strategy: "exactAsPath",
                },
              ]}
              hideIcon
            />
          ))
        ) : (
          <Box
            sx={{
              fontSize: "xs",
              color: "gray.500",
              px: 2.5,
            }}
          >
            No collections to show
          </Box>
        )}
      </List>
    </SecondarySidebarBase>
  )
}
